import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import useTranslation from '../../../../utils/translation'
import RadioButton from '../../customer-form/radioButton'

const SelectWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: -8px;

  & label {
    margin: 0;
    font-weight: normal;
  }
`

const ErrorMessage = styled.span`
  color: ${theme('forms.colors.invalid')};
  font-size: ${theme('forms.errorMessage.fontSize')};
  text-align: left;
  display: block;
  padding-top: 7px;
`

export const FormSelectQuestion = ({ question, answers, onChange }) => {
  const t = useTranslation('app.form')
  const onSelectChange = useCallback(
    (event) => {
      const checked = event.target.checked
      const value = event.target.value
      if (checked) {
        onChange([value])
      } else {
        onChange([])
      }
    },
    [onChange]
  )

  if (!question.options?.length) {
    return null
  }

  const errorMessage = useMemo(() => {
    if (question.notAnswered === undefined) {
      return undefined
    }
    if (question.notAnswered) {
      return question.requiredText || t('required')
    }
    return undefined
  }, [question.notAnswered, question.requiredText, t])

  return (
    <>
      <SelectWrapper>
        {question.options.map((o) => (
          <RadioButton
            data-selected={answers.includes(o.name)}
            data-track={`option-${o.name}`.toLowerCase()}
            value={o.name}
            label={o.text || o.firstText || o.name}
            name={question.questionText.replaceAll(' ','')}
            checked={answers.includes(o.name)}
            onChange={onSelectChange}
          />
        ))}
      </SelectWrapper>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  )
}
